<template>
    
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
    >
        <v-app-bar-nav-icon @click.stop="menu" />
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <v-img
          :src="require('@/assets/images/logotitulo.png')"
          aspect-ratio="4"
          max-width="200"
          max-height="60"
          contain
        ></v-img>
      </v-toolbar-title>
     
      <v-spacer />
      <v-btn
        icon
        large
      >
        <v-menu offset-y>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
          color="black"
          dark
          
           v-on="{ ...tooltip, ...menu }"
          icon
        >
          <v-icon large>mdi-account-circle</v-icon>
        </v-btn>
          </template>
          <span> {{user.name}} </span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="move(item.ruta)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      </v-btn>
          </v-app-bar>
    
</template>
<script>
export default {
    data: () => ({
      dialog: false,
      drawer: null,

       items: [
       // { title: 'Perfil', ruta: '/perfil'},
        { title: 'Cerrar Sesión', ruta: '/logout'},
        
      ],
      
    }),

    computed: {
      user(){

        return this.$store.state.currentUser.user;

      }
    },

    methods: {
        menu:function(){

            this.$store.commit('mutation_drawer');
            

        },

        move:function(path){
       if (path == '/logout') {
            this.$store.commit("logout");
            this.$router.push({ path: "/login" });
       }else{
         if (this.$route.path != path) {
          this.$router.push({path: path});  
        }
       }
       
      }
    },

}
</script>